import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<{
	default: [
		'headingLabel',
		'multiAppBodyLabel',
		'singleAppBodyLabel',
		'callToActionForMultiAppLabel',
		'callToActionForSingleAppLabel',
		'dismissLabel',
	];
	modal: [
		'modalTitle',
		'modalSubtitle',
		'modalTeammatesEmpty',
		'modalTeammatesFew',
		'modalTeammatesMany',
		'modalTeammatesLots',
		'modalClose',
		'modalDismiss',
	];
}> = defineContent({
	// `default` holds the side-nav banner copy; `role: 'title'` / `role: 'description'`
	// mark the two descriptors the offline content loader / reranker reads.
	default: {
		headingLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.heading',
			defaultMessage: 'See more at a glance',
			description: 'Heading for the Confluence 3p connect your tools side nav nudge.',
			role: 'title',
		},
		multiAppBodyLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.multi-app-body',
			defaultMessage: 'Connect your apps to embed rich links in this space.',
			description: 'Body text for the Confluence 3p connect your tools side nav nudge.',
			role: 'description',
		},
		singleAppBodyLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.single-app-body',
			defaultMessage: 'Connect {appName} to embed rich links in this space.',
			description: 'Body text for the Confluence 3p connect your tools side nav nudge.',
		},
		callToActionForMultiAppLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action',
			defaultMessage: 'Connect apps',
			description: 'Call to action button on the Confluence 3p connect your tools side nav nudge.',
		},
		callToActionForSingleAppLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action',
			defaultMessage: 'Connect {appName}',
			description: 'Call to action button on the Confluence 3p connect your tools side nav nudge.',
		},
		dismissLabel: {
			id: 'post-office.confluence-connect-3p-tools-nudge.dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button on the Confluence 3p connect your tools side nav nudge.',
		},
	},
	// `modal` holds the "connect your most-used apps" modal copy.
	modal: {
		modalTitle: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.title',
			defaultMessage: 'Connect your most-used apps',
			description: 'Title of the modal that allows users to connect 3rd party tools.',
			role: 'title',
		},
		modalSubtitle: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.subtitle',
			defaultMessage:
				'<strong>Bring your team\u2019s work</strong> into Confluence pages with rich, interactive previews \u2013 no tab-switching needed.',
			description: 'Subtitle of the modal that allows users to connect 3rd party tools.',
			role: 'description',
		},
		modalTeammatesEmpty: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty',
			defaultMessage: 'Teams stay in sync by seeing live updates directly in Confluence.',
			description:
				'Shown below the connector list when no teammates have connected an app (0 teammates).',
		},
		modalTeammatesFew: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.few',
			defaultMessage: 'Your team is already using {appName} to work smarter.',
			description: 'Shown below the connector list when 1-20 teammates have connected the app.',
		},
		modalTeammatesMany: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.many',
			defaultMessage:
				'\uD83D\uDE4C <strong>{numTeammates} teammates</strong> already connected {appName} to Confluence.',
			description: 'Shown below the connector list when 21-50 teammates have connected the app.',
		},
		modalTeammatesLots: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots',
			defaultMessage:
				'\uD83D\uDE4C <strong>50+ teammates</strong> already connected {appName} to Confluence.',
			description:
				'Shown below the connector list when more than 50 teammates have connected the app.',
		},
		modalClose: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.close',
			defaultMessage: 'Close',
			description: 'Close button in the 3p tools modal.',
		},
		modalDismiss: {
			id: 'post-office.confluence-connect-3p-tools-nudge.modal.dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button in the 3p tools modal footer.',
		},
	},
});
